const diagrams = {
	group: "block",
	draggable: true,
	attrs: {
		src: { default: null },
		title: { default: null },
		content: { default: null },
		diagramName: { default: null },
		width: { default: null },
		height: { default: null },
	},
};

export default diagrams;
